// Module
var code = "<p class=\"p7\"> <span class=\"credits__title\">Foto di:</span> <span class=\"credits__author bold underlined\"></span> </p> ";
// Exports
export default code;